const messages: Record<string, [string, string]> = {
  'paymentPrinter.title': ['正在確認印表機狀態', 'Checking the printer'],
  'paymentPrinter.waiting': [
    '正在等待印表機檢查結果，確認可列印後才能付款。尚未送出刷卡。',
    'Waiting for a recent printer check before payment. No card transaction has been sent.',
  ],
  'paymentPrinter.blocked': [
    '印表機缺紙、忙碌或狀態異常，暫停付款。請補紙或洽服務人員。',
    'The printer is out of paper, busy, or unavailable. Payments are paused. Refill paper or ask staff.',
  ],
  'paymentPrinter.disabled': [
    '列印服務未啟用，暫停付款，請洽服務人員。',
    'Printing is disabled. Payments are paused. Please ask staff.',
  ],
  'paymentPrinter.upgrade': [
    '列印服務無法提供檢查時間，暫停付款，請洽服務人員更新服務。',
    'The printing service cannot report when it last checked the printer. Payments are paused. Ask staff to update the service.',
  ],
  'paymentPrinter.timeout': [
    '等待印表機檢查逾時，尚未送出刷卡。請稍後重新操作或洽服務人員。',
    'The printer check timed out. No card transaction has been sent. Try again later or ask staff.',
  ],
  'paymentPrinter.unavailable': [
    '無法確認印表機狀態，尚未送出刷卡。請確認列印服務或洽服務人員。',
    'Unable to verify the printer. No card transaction has been sent. Check the printing service or ask staff.',
  ],
  'payment.retryNotice': [
    '已依目前票價與名額重新建立訂單，請確認行程與總金額後再付款。',
    'Your order has been rebuilt using current prices and availability. Check your itinerary and total before paying.',
  ],
  'payment.testAmounts': [
    '實機測試：僅限 {amounts} 訂單。',
    'Terminal testing: only orders for {amounts} are allowed.',
  ],
  'payment.unbound': [
    '此瀏覽器尚未綁定售票機，請先設定機台代號。',
    'This browser is not linked to a kiosk. Set the kiosk code first.',
  ],
  'payment.setup': ['設定售票機', 'Set up kiosk'],
  'payment.checking': ['正在確認付款方式…', 'Checking payment methods…'],
  'payment.offline': [
    '目前離線，請確認網路連線。',
    'You are offline. Check the network connection.',
  ],
  'payment.checkFailed': [
    '無法取得付款方式：{message}',
    'Unable to load payment methods: {message}',
  ],
  'payment.checkAgain': ['重新確認付款方式', 'Check payment methods again'],
  'payment.unavailable': [
    '此訂單目前無可用付款方式，請確認機台設定與金額。',
    'No payment method is available for this order. Check the kiosk settings and amount.',
  ],
  'payment.cancelRetry': ['取消重新付款並返回首頁', 'Cancel retry and return home'],
  'paymentProgress.queryTitle': ['正在查詢付款結果', 'Checking payment status'],
  'paymentProgress.retryTitle': ['正在確認付款條件', 'Checking payment availability'],
  'paymentProgress.payTitle': ['請留意下方刷卡機', 'Watch the card reader below'],
  'paymentProgress.notSentTitle': ['尚未送出刷卡', 'Payment not sent'],
  'paymentProgress.refundTitle': ['已收款，尚未出票', 'Payment received, tickets not issued'],
  'paymentProgress.declinedTitle': ['交易未完成', 'Transaction not completed'],
  'paymentProgress.unknownTitle': ['付款結果待確認', 'Payment status unconfirmed'],
  'paymentProgress.payDescription': [
    '請等待刷卡機顯示付款金額及刷卡提示後，再感應或插卡。',
    'Wait for the card reader to display the amount and payment prompt before tapping or inserting your card.',
  ],
  'paymentProgress.queryDescription': [
    '正在查詢原交易，這個操作不會再次刷卡。',
    'Checking the original transaction. This will not charge your card again.',
  ],
  'paymentProgress.retryDescription': [
    '正在確認原訂單與刷卡機狀態，請稍候。',
    'Checking the original order and card reader. Please wait.',
  ],
  'paymentProgress.notSentDescription': [
    '本次尚未送出刷卡。請確認下方提示後重新操作。',
    'The payment request has not been sent. Check the message below before trying again.',
  ],
  'paymentProgress.refundDescription': [
    '款項已收到，但這筆訂單未能出票。請至服務櫃檯辦理退款。',
    'Payment was received, but tickets could not be issued. Please visit the service counter for a refund.',
  ],
  'paymentProgress.declinedRetryDescription': [
    '本次交易未完成，請點選「保留選購內容重新付款」，確認行程與金額後再次付款。',
    'The transaction was not completed. Select “Keep selection and retry payment”, then check your itinerary and amount before paying again.',
  ],
  'paymentProgress.declinedDescription': [
    '本次交易未完成，目前無法重新付款。請查詢付款結果或洽櫃檯協助。',
    'The transaction was not completed. Payment cannot be retried yet. Check the payment status or ask at the service counter.',
  ],
  'paymentProgress.unknownDescription': [
    '系統會自動查詢原交易，確認付款與票券成功後將繼續出票。請勿重複刷卡；也可洽服務櫃檯。',
    'We will check the original transaction automatically and continue once payment and tickets are confirmed. Do not pay again. You can also ask at the service counter.',
  ],
  'paymentProgress.notSentCaution': ['本次尚未送出刷卡', 'The payment request has not been sent'],
  'paymentProgress.retryCaution': ['請重新確認行程與金額', 'Check your itinerary and amount again'],
  'paymentProgress.unavailableCaution': ['目前無法重新付款', 'Payment cannot be retried yet'],
  'paymentProgress.noRepeat': ['請勿重複刷卡', 'Do not pay again'],
  'paymentProgress.eyebrow': ['購票付款', 'Ticket payment'],
  'paymentProgress.order': ['本次訂單', 'Your order'],
  'paymentProgress.amount': ['訂單金額', 'Order total'],
  'paymentProgress.orderNumber': ['訂單編號', 'Order number'],
  'paymentProgress.responseCode': ['刷卡回應碼', 'Card response code'],
  'paymentProgress.notSentNotice': [
    '處理完成後，可按下「重新操作」。',
    'Once the issue is resolved, select “Try again”.',
  ],
  'paymentProgress.retryNotice': [
    '保留選購內容後，仍須再次確認才能開始付款。',
    'Your selection will be kept. You must confirm it again before payment starts.',
  ],
  'paymentProgress.unavailableNotice': [
    '尚未確認可重試或刷卡機尚未恢復，請稍後查詢付款結果或洽櫃檯。',
    'A retry is not yet authorized or the card reader is not ready. Check the payment status later or ask at the service counter.',
  ],
  'paymentProgress.counterNotice': [
    '請拍下上方訂單編號，提供櫃檯協助查詢。',
    'Take a photo of the order number above so staff can help you check it.',
  ],
  'paymentProgress.detail': ['處理提示', 'What to do'],
  'paymentProgress.actions': ['付款操作', 'Payment actions'],
  'paymentProgress.tryAgain': ['重新操作', 'Try again'],
  'paymentProgress.keepRetry': ['保留選購內容重新付款', 'Keep selection and retry payment'],
  'paymentProgress.checkResult': ['查詢付款結果', 'Check payment status'],
  'paymentProgress.reselect': ['重新選擇行程', 'Choose another itinerary'],
  'paymentProgress.home': ['返回首頁', 'Return home'],
  'paymentProgress.wait': [
    '處理中請稍候，請勿重複刷卡，完成前請勿離開。',
    'Please wait. Do not pay again or leave before processing is complete.',
  ],
  'paymentProgress.homeNotice': [
    '返回首頁不會取消已送出的刷卡交易。',
    'Returning home will not cancel a card transaction that has already been sent.',
  ],
  'cardGuide.label': ['刷卡操作指引', 'Card payment instructions'],
  'cardGuide.locationImage': [
    '刷卡機位於 Kiosk 螢幕下方正中央',
    'The card reader is directly below the centre of the kiosk screen',
  ],
  'cardGuide.locationTitle': ['刷卡機在這裡', 'Card reader here'],
  'cardGuide.location': ['螢幕下方・正中央', 'Below the screen, in the centre'],
  'cardGuide.actionImage': [
    '持信用卡靠近刷卡機感應區，或依端末機指示插卡',
    'Tap your card on the reader or insert it as instructed by the terminal',
  ],
  'cardGuide.actionTitle': ['等待提示後再刷卡', 'Wait for the payment prompt'],
  'cardGuide.action': [
    '顯示付款金額及刷卡提示後，再感應或插卡',
    'Tap or insert your card only after the amount and payment prompt appear',
  ],
  'cardGuide.reminder': [
    '已刷卡？請等待付款結果，勿再次刷卡。',
    'Already tapped or inserted your card? Wait for the result. Do not pay again.',
  ],
};

// Japanese is not currently offered in the UI; retain the Chinese fallback.
export const PAYMENT_STRINGS: Record<string, [string, string, string]> = Object.fromEntries(
  Object.entries(messages).map(([key, [zh, en]]) => [key, [zh, en, zh]]),
);
